import React, { useContext, useEffect, useState } from "react"
import tw from "twin.macro"
import { SegmentLanderHeroProps } from "./SegmentLanderHero.d"
import { LanguageContext } from "../../../../contexts/Language"
import { ContactContext } from "../../../../contexts/Contact"
import { useTealiumContext } from "../../../../contexts/Tealium"
import useTealiumEvent from "../../../../hooks/Tealium/useTealiumEvent"
import {
  detectMobileView,
  getCTALinkValue,
  parseDisclaimerBlocks,
} from "../../../../helpers"
import { toggleDisclaimersModal } from "../../../../contexts/Disclaimers/actions"
import { ButtonLink } from "../../../atoms/Button"
import { CTA } from "../../../../global"
import { set } from "husky"

const SegmentLanderHero: React.FC<SegmentLanderHeroProps> = ({
  contentBackgroundColor,
  ctas,
  desktopImage,
  mobileImage,
  pageHeading,
  subheading,
}) => {
  const { _ } = useContext(LanguageContext)
  const [_state, dispatch] = useContext(ContactContext)
  const [heroImg, setHeroImg] = useState(desktopImage)
  const [isMobileView, setIsMobileView] = useState(false)
  const { trackTealEvent } = useTealiumEvent()

  useEffect(() => {
    const isMobileView = detectMobileView()
    if (isMobileView) {
      setHeroImg(mobileImage)
      setIsMobileView(true)
    } else {
      setHeroImg(desktopImage)
      setIsMobileView(false)
    }
  }, [])

  return (
    <section>
      <div
        css={[tw`grid grid-cols-1 h-auto lg:(grid-cols-7 h-[45rem] relative)`]}
      >
        <div
          css={[
            tw`col-span-1 order-2 flex justify-center  lg:(col-span-3 order-1 justify-end items-center px-10 gap-2 )`,
            `background: ${`${contentBackgroundColor?.hex}`};`,
          ]}
        >
          <div
            css={tw`grid-cols-1 lg:(absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-screen grid grid-cols-1 grid-cols-7 z-50)`}
          >
            <div
              css={[
                tw`col-span-1 py-10 px-10 flex justify-center items-center text-left text-white gap-2 lg:(col-span-3 justify-end  py-0 px-16 )`,
              ]}
            >
              <div css={[tw`flex flex-col items-center gap-5 max-w-[28rem] `]}>
                <h1
                  css={[
                    tw`text-2xl text-center font-semibold`,
                    // tw`text-4xl flex  font-semibold lg:text-5xl xl:text-6xl`,
                  ]}
                >
                  {parseDisclaimerBlocks(pageHeading, selection =>
                    dispatch(toggleDisclaimersModal(selection)),
                  )}
                </h1>
                <div css={[tw`flex flex-col gap-1`]}>
                  <h2
                    css={[
                      tw`text-5xl block text-center font-semibold leading-[104.6%] lg:text-5xl xl:text-6xl`,
                    ]}
                  >
                    {parseDisclaimerBlocks(subheading, selection =>
                      dispatch(toggleDisclaimersModal(selection)),
                    )}
                  </h2>
                </div>
                {/* CTAs */}
                {ctas && (
                  <div
                    css={[
                      tw`flex flex-col justify-center content-center items-center gap-5 my-3 w-fit lg:(gap-4 flex-row w-full)`,
                    ]}
                  >
                    {ctas?.map((cta: CTA, index: number) => {
                      const link = getCTALinkValue(cta)
                      const isInventoryLink = link.includes("inventory")
                      const isOffersLink = link.includes("offers")

                      return (
                        <ButtonLink
                          to={link}
                          target={
                            cta?.linkType === "external" ? "_blank" : "_self"
                          }
                          key={cta?.title}
                          {...{ [cta?.buttonType]: true }}
                          analytics-id={`${isInventoryLink ? "inventory" : isOffersLink ? "offers" : "cta"}:hero:`}
                          css={[
                            tw`w-full px-10`,
                            cta?.buttonType === "secondary" &&
                              tw`bg-white bg-opacity-90 text-black px-8`,
                          ]}
                          onClick={() => {
                            trackTealEvent({
                              tealium_event: isInventoryLink
                                ? "view_inventory_click"
                                : cta?.linkType === "anchor"
                                  ? "lander_anchor"
                                  : cta?.linkType === "external"
                                    ? "cta_click"
                                    : "nav_click",
                              ...(cta?.linkType === "internal" && {
                                link_href: link,
                              }),
                              ...(cta?.linkType === "internal" && {
                                coupon_module_text: cta?.title,
                              }),
                              ...(cta?.linkType === "external" && {
                                coupon_module_text: cta?.title,
                              }),
                              ...(cta?.linkType === "external" && {
                                link_href: `${link}`,
                              }),
                              ...(cta?.linkType === "anchor" && {
                                anchor_button_text: cta?.title,
                              }),
                            })
                          }}
                        >
                          {cta?.title}
                        </ButtonLink>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          css={[
            isMobileView
              ? tw` h-[15rem] lg:( h-auto) `
              : tw`h-[18rem] lg:( h-auto) `,
            tw`col-span-1 order-1 bg-cover bg-center bg-no-repeat relative lg:(col-span-4 order-2)`,
            heroImg?.image?.asset &&
              `background-image:url(${heroImg?.image?.asset?.gatsbyImageData?.images?.fallback?.src});`,
          ]}
        ></div>
      </div>
    </section>
  )
}
export default SegmentLanderHero
